import { FinancialSettlementAdvancePayment, VisitSettlement } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { createVisitor } from '~libs.typescript';

export const visitCancelContentVisitor = createVisitor<
   VisitSettlement | null,
   {
      visitCancelPaidAdvancePayment: FinancialSettlementAdvancePayment;
      visitCancelUnpaidAdvancePayment: void;
      visitCancel: void;
   }
>((visitSettlement, visitor) => {
   const advancePayment = visitSettlement?.advancePayments.at(0);

   if (advancePayment) {
      if (advancePayment.totalAmount.asNumber() === 0) {
         return visitor.visitCancelUnpaidAdvancePayment?.();
      }
      return visitor.visitCancelPaidAdvancePayment?.(advancePayment);
   }

   return visitor.visitCancel?.();
});
